import $ from 'jquery';
import moment from 'moment';
import { renderEdit } from './form';
import { bindInteractions } from './postpone';

export const index = ctx => {
  bindForm();
  const id = ctx.params.id;
  if (id && !isNaN(parseInt(id, 10))) {
    // Bind form handling
    renderEdit(id);

    // Enable postpone behavior
    bindInteractions(id);
  }
};

function bindForm() {
  $('.ui.calendar').calendarFr({
    type: 'date',
    parser: {
      date: (text, settings) => moment(text, 'DD/MM/YYYY').toDate(),
    },
    formatter: {
      datetime: date => {
        if (!date) {
          return '';
        }

        return moment(date).format('DD/MM/YYYY');
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/modules/news/index.js